type Props = {
  children: string;
};

const SearchGroupTitle = ({ children }: Props) => (
  <span className="headline5 text-primary">{children}</span>
);

export { SearchGroupTitle };
